import { curryN } from "ramda";
export const mapObj = (kf, vf, x) => {
    const r = {};
    for (const k in x) {
        r[kf(k)] = vf(x[k]);
    }
    return r;
};
export default curryN(3, mapObj);
//# sourceMappingURL=mapObj.mjs.map